const selectors = {
  outer: '[data-drawer-search]',
  wrapper: '[data-search-popdown-wrap]',
  input: '[data-predictive-search-input]',
  clear: '[data-clear-input]',
};

class SearchDrawer {
  constructor(section) {
    this.outer = section.container.querySelector(selectors.outer);
    if (this.outer) {
      this.wrapper = this.outer.querySelector(selectors.wrapper);
      this.input = this.outer.querySelector(selectors.input);
      this.clear = this.outer.querySelector(selectors.clear);
      this.init();
    }
  }

  init() {
    this.clear.addEventListener(
      'click',
      function (evt) {
        evt.preventDefault();
        this.clearInput();
      }.bind(this)
    );
  }

  clearInput() {
    this.input.value = '';
    this.input.dispatchEvent(new CustomEvent('clear', {bubbles: false}));
    this.input.focus();
  }
}

const searchDrawer = {
  onLoad() {
    this.searchDrawer = new SearchDrawer(this);
  },
  onUnload: function () {
    if (this.searchDrawer && typeof this.searchDrawer.unload === 'function') {
      this.searchDrawer.unload();
    }
  },
};

export default searchDrawer;
